import {ANIMATIONS, TYPOGRAPHY} from '../app.config';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';
import Splitting from 'splitting';
gsap.registerPlugin(ScrollTrigger);

export default class Typography {

  constructor(context) {
    this.context = context;
    ANIMATIONS && this.init();
  }

  initAnimations() {
    this.items.forEach(el => {
      switch (el.type) {
        case 'title':
          TYPOGRAPHY && this.titleAnimation(el.items)
          break;
        case 'text':
          TYPOGRAPHY && this.textAnimation(el.items)
          break;
      }
    })
  }

  titleAnimation(items) {
    items.forEach(item => {
      const chars = item.querySelectorAll('.char');
      chars.forEach(char => gsap.set(char.parentNode, { perspective: 2000 }));

      gsap.fromTo(chars, {
        'will-change': 'opacity, transform, filter',
        opacity: 0,
        rotationX: -90,
        yPercent: 120,
      }, {
        ease: 'expo.out',
        duration: 2.3,
        opacity: 1,
        rotationX: 0,
        yPercent: 0,
        stagger: {
            each: 0.03,
            from: 0
        },
      });
    })
  }

  textAnimation(items) {
    items.forEach(item => {
      const chars = item.querySelectorAll('.char');
      chars.forEach(char => gsap.set(char.parentNode, { perspective: 2000 }));

      gsap.fromTo(chars, {
        'will-change': 'opacity, transform, filter',
        opacity: 0,
        rotationX: -90,
        yPercent: 120,
      },
      {
          ease: 'expo.out',
          opacity: 1,
          rotationX: 0,
          yPercent: 0,
          stagger: {
              each: 0.03,
              from: 0
          },
          scrollTrigger: {
            trigger: item,
            start: 'top 95%',
            end: 'top 40%',
            scrub: 6,
          }
      });
    });
  }

  init() {
    const elements = Array.from(this.context.querySelectorAll('[data-animate-typo]'));
    const titleAnimation = elements.filter(x => x.dataset.animateTypo === 'title');
    const textAnimation = elements.filter(x => x.dataset.animateTypo === 'text');
    this.items = [{
      type: 'title',
      items: titleAnimation ? titleAnimation : []
    },{
      type: 'text',
      items: textAnimation ? textAnimation : []
    }]
    this.initAnimations();
  }

  static split(context) {
    const target = context.querySelectorAll('[data-splitting]');
    TYPOGRAPHY && Splitting({ target: target });
  }
}
